<template>
  <v-text-field
    v-model="value"
    :label="translatedLabel"
    :name="name || label"
    hint="MM/AAAA"
    v-mask="'##/####'"
    @blur="onBlur"
    autocomplete="ansdoasdjosk"
    :rules="regras"
    hide-details
    class="
      input-style
      font-size-input
      text-light-input
      placeholder-light
      input-icon
    "
    dense
    flat
    filled
    solo
  >
  </v-text-field>
</template>

<script>
import { translateIfMessageExists } from "@/utils/i18n";

export default {
  name: "CampoCompetencia",

  props: {
    label: { type: String, default: "Data" },
    payload: { type: String, required: false },
    name: { type: String, required: false },
    // Competência opcional (ex.: fim de vigência em aberto): só valida o formato.
    opcional: { type: Boolean, default: false },
  },

  mounted() {
    setTimeout(() => {
      this.setFromPayload(this.payload);
    }, 700);
  },

  watch: {
    payload: function (val) {
      this.setFromPayload(val);
    },
  },

  data() {
    return {
      value: "",
    };
  },

  methods: {
    onBlur() {
      this.$emit("date", this.formatedValue);
    },

    setFromPayload(payload) {
      if (!payload) {
        this.value = "";
        return;
      }

      if (String(payload).includes("/")) {
        this.value = String(payload);
        return;
      }

      if (
        this.$options.filters &&
        this.$options.filters.competenciaParaLeitura
      ) {
        this.value =
          this.$options.filters.competenciaParaLeitura(payload) || "";
        return;
      }

      this.value = String(payload);
    },

    isValidCompetencia(value) {
      const match = String(value || "")
        .trim()
        .match(/^(\d{2})\/(\d{4})$/);
      if (!match) {
        return false;
      }

      const mes = Number(match[1]);
      return mes >= 1 && mes <= 12;
    },

    validaData() {
      if (!this.value) {
        return true;
      }
      return this.isValidCompetencia(this.value)
        ? true
        : this.$t("Data_invalida");
    },
  },

  computed: {
    regras() {
      const formato = () => this.validaData();
      return this.opcional
        ? [formato]
        : [(v) => !!v || this.$t("Campo_obrigatorio"), formato];
    },

    translatedLabel() {
      return translateIfMessageExists(this.$i18n, this.label);
    },

    formatedValue: function () {
      const data = String(this.value || "").trim();
      if (!this.isValidCompetencia(data)) {
        return null;
      }

      const [mes, ano] = data.split("/");
      return `${ano}-${mes}-01`;
    },
  },
};
</script>

<style></style>
